"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _lodash2 = _interopRequireDefault(require("lodash.capitalize"));

var _reactI18next = require("react-i18next");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactComponents = require("@cimpress/react-components");

var _FieldDisplay = _interopRequireDefault(require("./FieldDisplay"));

var _propTypes2 = require("../propTypes");

var _StatusLabel = _interopRequireDefault(require("./StatusLabel"));

var _ClaimCategory = _interopRequireDefault(require("./ClaimCategory"));

var _useMerchantConfig2 = _interopRequireDefault(require("./hooks/useMerchantConfig"));

var _environments = require("../constants/environments");

var _index = _interopRequireDefault(require("../i18n/index"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  top: 16;\n  right: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  border-bottom: 1px solid ", ";\n  padding: 16px 0;\n\n  &:first-child {\n    padding-top: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ClaimWrapper = _styledComponents["default"].div(_templateObject(), _reactComponents.colors.platinum);

var StatusWrapper = _styledComponents["default"].div(_templateObject2());

var Claim = function Claim(_ref) {
  var claim = _ref.claim,
      locale = _ref.locale,
      environment = _ref.environment,
      accessToken = _ref.accessToken;

  var _useTranslation = (0, _reactI18next.useTranslation)('reactClaims', {
    i18n: _index["default"]
  }),
      t = _useTranslation.t;

  var id = claim.id,
      status = claim.status,
      responsibleParty = claim.responsibleParty,
      preferredResolution = claim.preferredResolution,
      _claim$merchantClaimC = claim.merchantClaimCategories,
      merchantClaimCategories = _claim$merchantClaimC === void 0 ? [] : _claim$merchantClaimC,
      assignee = claim.assignee,
      merchantId = claim.merchantId,
      _claim$items = claim.items,
      items = _claim$items === void 0 ? [] : _claim$items,
      created = claim.created,
      _claim$_links = claim._links,
      _links = _claim$_links === void 0 ? {} : _claim$_links;

  var _useMerchantConfig = (0, _useMerchantConfig2["default"])({
    environment: environment,
    accessToken: accessToken,
    merchantId: merchantId
  }),
      merchantDisplayName = _useMerchantConfig.merchant.displayName;

  var createdPrettyPrint = new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
    timeStyle: 'medium'
  }).format(new Date(created));
  var claimLink = (0, _lodash["default"])(_links, 'ui.href');
  var affectedQuantity = items.map(function (item) {
    return (0, _lodash["default"])(item, 'quantity', 0);
  }).reduce(function (total, val) {
    return total + val;
  }).toString();
  return _react["default"].createElement(ClaimWrapper, null, _react["default"].createElement(StatusWrapper, null, _react["default"].createElement(_StatusLabel["default"], {
    status: status,
    assignee: assignee
  })), _react["default"].createElement(_FieldDisplay["default"], {
    name: t('id'),
    value: _react["default"].createElement("a", {
      href: claimLink,
      target: "_blank",
      rel: "noopener noreferrer"
    }, id)
  }), _react["default"].createElement(_FieldDisplay["default"], {
    name: t('merchant'),
    value: merchantDisplayName
  }), _react["default"].createElement(_FieldDisplay["default"], {
    name: t('responsibleParty'),
    value: (0, _lodash2["default"])(responsibleParty)
  }), _react["default"].createElement(_FieldDisplay["default"], {
    name: t('created'),
    value: createdPrettyPrint
  }), _react["default"].createElement(_FieldDisplay["default"], {
    name: t('items'),
    value: items.map(function (_ref2) {
      var itemId = _ref2.itemId;
      return _react["default"].createElement("div", {
        key: itemId
      }, itemId);
    })
  }), _react["default"].createElement(_FieldDisplay["default"], {
    name: t('affectedQuantity'),
    value: affectedQuantity
  }), _react["default"].createElement(_FieldDisplay["default"], {
    name: t('preferredResolution'),
    value: (0, _lodash2["default"])(preferredResolution)
  }), _react["default"].createElement(_FieldDisplay["default"], {
    name: t('categories'),
    value: merchantClaimCategories.map(function (category) {
      return _react["default"].createElement(_ClaimCategory["default"], {
        key: category,
        category: category
      });
    })
  }));
};

Claim.propTypes = {
  claim: _propTypes2.claimShape.isRequired,
  locale: _propTypes["default"].string,
  environment: _propTypes["default"].oneOf([_environments.PRODUCTION, _environments.INTEGRATION]),
  accessToken: _propTypes["default"].string.isRequired
};
Claim.defaultProps = {
  locale: 'en',
  environment: _environments.PRODUCTION
};
var _default = Claim;
exports["default"] = _default;